import { CreateActivityFormData, ActivityType } from './activity.types';

export const ACTIVITY_INITIAL_VALUES: CreateActivityFormData = {
  activityType: 'Flight' as ActivityType,

  name: '',

  startDate: '',
  startTime: '',
  endDate: '',
  endTime: '',
  departureDate: '',
  departureTime: '',
  arrivalDate: '',
  arrivalTime: '',
  checkInDate: '',
  checkInTime: '',
  checkOutDate: '',
  checkOutTime: '',
  date: '',
  time: '',

  flightFrom: '',
  flightTo: '',
  place: '',
  country_from: '',
  country_to: '',

  airline: '',
  flightNumber: '',
  ticketBookingNumber: '',
  seatNumber: '',
  carrierName: '',
  bookingNumber: '',
  departureLocation: '',
  departureAddress: '',
  arrivalLocation: '',
  arrivalAddress: '',
  vehicleDescription: '',
  numberOfPassengers: '',

  vehicleType: '',
  pickupAddress: '',
  sameAsPickupAddress: false,
  dropOffAddress: '',
  officeAddress: '',

  address: '',

  shipName: '',
  startingPortName: '',
  startingPortAddress: '',
  sameAsStartingPort: false,
  endingPortName: '',
  endingPortAddress: '',
  cabinType: '',
  cabinNumber: '',

  departureStation: '',
  arrivalStation: '',
  trainType: '',
  trainNumber: '',
  class: '',

  borderCheckpoint: '',

  parkingSpaceNumber: '',

  phone: '',
  email: '',
  link: '',

  notes: '',
  amountSpent: '',

  documentName: '',
  documentTags: [],
  attachments: [],

  address_details: undefined,
  pickupAddress_details: undefined,
  dropOffAddress_details: undefined,
  officeAddress_details: undefined,
  departureAddress_details: undefined,
  arrivalAddress_details: undefined,
  startingPortAddress_details: undefined,
  endingPortAddress_details: undefined,

  flightFrom_details: undefined,
  flightTo_details: undefined,
  airline_details: undefined,
};

export const getResetValues = (): CreateActivityFormData => {
  return { ...ACTIVITY_INITIAL_VALUES };
};
